import { createContext } from 'react';
import { UserDataContextType } from './typings';

const UserDataContext = createContext<UserDataContextType>({
  users: null,
  getUserByEmail: () => undefined,
});

export default UserDataContext;
